import React, { FC, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { InfoMessage } from '@eika/attention-message';
import { IconTypes } from '@eika/icon';
import { Input } from '@eika/input';

import { SivilstandWeb } from '../../generated-types';
import { usePersonNavn } from '../../hooks/useLaantaker';
import { useTranslation } from '../../translations';
import { KontaktinformasjonFormData } from '../kontaktinformasjon/kontaktinformasjon';
import MedlaantakerKontaktinfo from './medlaantakerKontaktinfo';

const MedlaantakerNew: FC = () => {
    const { kontaktinfoMedlaantaker, validationMessage } = useTranslation();
    const {
        register,
        setValue,
        watch,
        formState: { errors },
    } = useFormContext<KontaktinformasjonFormData>();
    const { data: personNavn, isError } = usePersonNavn({
        foedselsnummer: { value: watch('medlaantaker.personnummer') },
        fornavn: watch('medlaantaker.fornavn'),
        etternavn: watch('medlaantaker.etternavn'),
        sivilstand: SivilstandWeb.UOPPGITT,
        adresse: watch('medlaantaker.adresse'),
    });

    useEffect((): void => {
        register('medlaantakerValid', { validate: (value) => value });
    }, [register]);

    useEffect((): void => {
        if (personNavn) {
            setValue('medlaantaker.etternavn', personNavn.etternavn);
            setValue('medlaantaker.sivilstand', personNavn.sivilstand);
            setValue('medlaantakerValid', true, { shouldValidate: true });
        } else {
            setValue('medlaantakerValid', false, { shouldValidate: true });
        }
    }, [personNavn, setValue]);

    return (
        <>
            <h2>{kontaktinfoMedlaantaker.title}</h2>
            <InfoMessage text={kontaktinfoMedlaantaker.infoNyMedlaantaker} icon={IconTypes.INFO_36} type="default" />
            <Input
                label={kontaktinfoMedlaantaker.labelFornavn}
                className="max-width-400"
                error={errors.medlaantaker?.fornavn?.message}
                {...register('medlaantaker.fornavn', {
                    required: `${validationMessage.requiredValue}`,
                    setValueAs: (value) => value.trim(),
                })}
            />
            <Input
                label={kontaktinfoMedlaantaker.labelEtternavn}
                className="max-width-400"
                error={errors.medlaantaker?.etternavn?.message}
                {...register('medlaantaker.etternavn', {
                    required: `${validationMessage.requiredValue}`,
                    setValueAs: (value) => value.trim(),
                })}
            />
            <Input
                inputMode="numeric"
                label={kontaktinfoMedlaantaker.labelFoedselsnummer}
                className="max-width-200"
                error={isError ? validationMessage.personnummerNavnDsf : errors.medlaantaker?.personnummer?.message}
                {...register('medlaantaker.personnummer', {
                    required: `${validationMessage.requiredValue}`,
                    minLength: { value: 11, message: validationMessage.foedselsnummerToShort },
                    maxLength: { value: 11, message: validationMessage.foedselsnummerToLong },
                    setValueAs: (value) => value.trim(),
                })}
            />
            <MedlaantakerKontaktinfo />
        </>
    );
};

export default MedlaantakerNew;
